import styled from "styled-components";
import { TablePageContent } from "components/TablePageLayout";
import { pxToRem } from "../../styles/utils";

export const VersionsPageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${pxToRem(12)};
`;

export const ContentWrapper = styled(TablePageContent)`
  margin-left: 0;
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  box-shadow: ${({ theme }) => theme.shadows.md}, ${({ theme }) => theme.shadows.ring};
  padding: ${pxToRem(32)} ${pxToRem(24)};
  overflow-x: auto;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${pxToRem(32)};
`;

export const Title = styled.h1`
  font-size: ${pxToRem(32)};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.ink};
`;


export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${pxToRem(8)};
  align-items: center;
`;


export const IconsContainer = styled.div`
  display: flex;
  gap: ${pxToRem(8)};
`;

/*
  Кнопка, а не картинка. По значку кликают — открывается состав версии.
  Картинке нельзя дать фокус с клавиатуры и нельзя нажать пробелом,
  поэтому здесь настоящая кнопка, а внутри инлайновый svg.
*/
export const IconsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ExternalLinkButton = styled.button`
  padding: ${pxToRem(16)} ${pxToRem(32)};
  border: none;
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  background: ${({ theme }) => theme.colors.brand};
  color: ${({ theme }) => theme.colors.white};
  font-size: ${pxToRem(20)};
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: ${({ theme }) => theme.colors.brandDark};
    transform: translateY(-2px);
  }
  
  &:active {
    transform: translateY(-1px);
  }
`;

/**
 * Иконки таблицы документов живут на одной компактной сетке.
 * Функциональные пиктограммы нейтральные по умолчанию и получают бренд
 * только при наведении; цветные DOCX/PDF/delete сохраняют смысловой цвет.
 */
export const DocumentFeatureButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: ${pxToRem(34)};
  height: ${pxToRem(34)};
  padding: ${pxToRem(5)};
  border: none;
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  background: transparent;
  color: ${({ theme }) => theme.colors.grayIcon};
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.inkSurface};
    color: ${({ theme }) => theme.colors.inkSoft};
  }

  &:focus-visible {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(1)};
  }
`;

export const DocumentFeatureGlyph = styled.svg`
  display: block;
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
  flex: 0 0 auto;
  color: inherit;
`;
